<script>
import { BFormText } from "bootstrap-vue";

export default {
  extends: BFormText
};
</script>